import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { UserService } from "../services/user.service";

@Directive({
    selector: "[hasPermission]",
})
export class PermissionDirective {

    constructor(
        private userService: UserService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) { }

    @Input()
    set hasPermission(permission: string) {
        if (this.userService.hasPermission(permission)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}